// extracted by mini-css-extract-plugin
module.exports = {"textCarousel":"styles_textCarousel__BrBrw","content":"styles_content__S3WJY","buttonGroup":"styles_buttonGroup__vJ9xZ","after":"styles_after__xKsHR"};